import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { Text } from '../../typography'

// this is exported to use for fields that have instructions that change based on state.
export const Instructions = styled(Text)`
    font-size: 14px;
    padding: 15px 0 0;
    margin: 0;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadFieldInstructions = ({ className, field }: Props) => {
    const instructions = CreationToolUploadField.instructions(field)
    const learnMoreUrl = CreationToolUploadField.learnMoreUrl(field)
    return instructions || learnMoreUrl ? (
        <Instructions className={className}>
            {instructions}{' '}
            {learnMoreUrl && (
                <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">
                    Learn More
                </a>
            )}
        </Instructions>
    ) : null
}

export default CreationUploadFieldInstructions
